<template>
  <div class="ps-update-page">
    <div class="ps-form-layout">
      <aside class="ps-sidebar">
        <div class="ps-side-card">
          <div class="ps-side-title">填写步骤</div>
          <button
            v-for="(sec, i) in sections"
            :key="sec.id"
            type="button"
            class="ps-step-item"
            :class="sectionStepClass(i)"
            @click="editGo(i)"
          >
            <span class="ps-step-label">{{ sec.title }}</span>
            <span class="ps-step-mark">{{ sectionStepMark(i) }}</span>
          </button>
          <div class="ps-side-hint">
            点击步骤切换模块，带 <b style="color: #ef4444">*</b> 的为必填项
          </div>
        </div>
      </aside>

      <div class="ps-content">
        <div class="ps-status-bar">
          <div class="ps-status-block">
            <span class="ps-status-label">当前状态</span>
            <StatusBadge
              :status="baseInfo && baseInfo.auditState"
              :text="statusBadgeText"
              :type="statusBadgeType"
            />
          </div>
          <div class="ps-status-block">
            <span class="ps-status-label">正在编辑</span>
            <span class="ps-status-value warn">{{ editingStatusText }}</span>
          </div>
          <div style="flex: 1"></div>
          <button
            v-if="canShowAuditActions"
            type="button"
            class="ps-btn ps-btn--blue"
            style="background: #43a91b; border-color: #43a91b"
            @click="approved('0', baseInfo)"
          >
            审核通过
          </button>
          <button
            v-if="canShowAuditActions"
            type="button"
            class="ps-btn ps-btn--outline-orange"
            style="color: #df0000; border-color: #df0000"
            @click="approved('1', baseInfo)"
          >
            审核驳回
          </button>
          <button
            v-if="showFooterActions"
            type="button"
            class="ps-btn ps-btn--white"
            :disabled="draftLoading"
            @click="saveDraft"
          >
            💾 暂存
          </button>
          <button
            v-if="
              showFooterActions &&
              ($store.state.role == 'school-role' ||
                $store.state.role == 'teacher-role')
            "
            type="button"
            class="ps-btn ps-btn--blue"
            :disabled="loading"
            @click="option()"
          >
            ✉ 提交
          </button>
          <button type="button" class="ps-btn ps-btn--white" @click="goBack">
            ↩ 返回
          </button>
        </div>

        <div
          class="ps-form-card"
          :class="{ 'is-origin-form': activeSection === 0 }"
        >
          <div v-show="activeSection === 0" id="baseInfo" class="ps-origin-base-embed">
            <BaseInfo
              :oldInfos="baseInfo"
              ref="baseInfoRef"
              @goStep="goStep"
              :isAdd="isAdd"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 1" id="teamInfo" class="ps-list-embed">
            <TeamInfo
              :oldInfos="baseInfo"
              ref="teamInfoRef"
              :cardTitle="baseInfoTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 2" id="budget" class="ps-list-embed">
            <Budget
              :oldInfos="baseInfo"
              ref="budgetRef"
              :cardTitle="budgetTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div
            v-show="activeSection === 3"
            id="capitalExpenditure"
            class="ps-list-embed"
          >
            <CapitalExpenditure
              :oldInfos="baseInfo"
              ref="capitalExpenditureRef"
              :cardTitle="capitalExpenditureTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 4" id="annualPlan" class="ps-list-embed">
            <AnnualPlan
              :oldInfos="baseInfo"
              ref="annualPlanRef"
              :cardTitle="annualPlanTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 5" id="activity" class="ps-list-embed">
            <Activity
              :oldInfos="baseInfo"
              ref="activityRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div
            v-show="activeSection === 6"
            id="brandBuilding"
            class="ps-list-embed"
          >
            <BrandBuilding
              :oldInfos="baseInfo"
              ref="teamBuildingRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div
            v-show="activeSection === 7"
            id="educatingPeople"
            class="ps-list-embed"
          >
            <EducatingPeople
              :oldInfos="baseInfo"
              ref="educatingPeopleRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
              :cardTitle="educatingPeopleTitle"
            />
          </div>
          <div
            v-show="activeSection === 8"
            id="achievement"
            class="ps-list-embed"
          >
            <Achievement
              :oldInfos="baseInfo"
              ref="achievementRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
              :cardTitle="achievementTitle"
            />
          </div>
          <div
            v-show="activeSection === 9"
            id="brandPropaganda"
            class="ps-list-embed"
          >
            <Propaganda
              :oldInfos="baseInfo"
              ref="PropagandaRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 10" id="result" class="ps-list-embed">
            <Effect
              :oldInfos="baseInfo"
              ref="resultRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
        </div>

        <div class="ps-footer-bar">
          <div class="ps-footer-tip">
            <span v-if="isAdd && !(baseInfo && baseInfo.id)">
              💡 请先填写基本信息并暂存，再完善其余模块
            </span>
            <span v-else>
              💡 按照申报书内容填报，可通过左侧步骤切换模块
            </span>
          </div>
          <div class="ps-footer-actions">
            <button type="button" class="ps-btn ps-btn--white" @click="editPrev">
              ← 上一步
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="editNext">
              下一步 →
            </button>
            <button
              v-if="
                showFooterActions &&
                ($store.state.role == 'school-role' ||
                  $store.state.role == 'teacher-role')
              "
              type="button"
              class="ps-btn ps-btn--blue"
              :disabled="loading"
              @click="option()"
            >
              ✉ 提交
            </button>
          </div>
        </div>
      </div>
    </div>

    <RateIcon
      ref="rateIcon"
      @onShowRateTable="onShowRateTable"
      v-if="$store.state.role === 'score-role'"
    />
    <RateTable ref="rateTable" />
    <a-modal
      v-model="visible"
      title="确定要驳回吗？"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOks()"
      @cancel="visible = false"
    >
      <p>驳回的理由是什么呢？</p>
      <a-input
        type="text"
        v-model="content"
        name=""
        id=""
        style="width: 100%; height: 50px"
        placeholder="请输入驳回的理由!"
      />
    </a-modal>
    <img
      ref="vsIcon"
      @click="onShowVs"
      src="~@/assets/images/vs.png"
      alt
      title="对比"
      class="vs-icon"
      v-if="isShowVsIcon && !isEdit"
    />
    <right-dialog ref="rightDialog" @preview="handlePreview"></right-dialog>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
          :dialogTitle="dialogTitle"
        ></newpreview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showvideo">
      <div class="preview-boxs" style="height: 600px">
        <videopreview
          :sj="sjData"
          @closePreview="showvideo = false"
        ></videopreview>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import BaseInfo from "./baseInfo.vue";
import TeamInfo from "./teamInfo.vue";
import Budget from "./budget.vue";
import CapitalExpenditure from "./capitalExpenditure.vue";
import AnnualPlan from "./annualPlan.vue";
import Effect from "./effect.vue";
import Activity from "./activity.vue";
import BrandBuilding from "./brandBuilding.vue";
import Honor from "./honor.vue";
import Propaganda from "./propaganda.vue";
import PracticeBase from "./practiceBase.vue";
import EducatingPeople from "./educatingPeople.vue";
import Achievement from "./achievement.vue";
import RateTable from "@/components/common/rateTable";
import RateIcon from "@/components/common/rateIcon";
import rightDialog from "@/components/common/rightDialog";
import newpreview from "@/components/common/newpreviews";
import videopreview from "@/components/common/videopreview";
import { FILE_VIEW_MAP } from "@/components/auditPage/data.js";
import { getAuditLevel, canRoleAuditAtLevel } from "@/api/auditTask.js";
import {
  getCourseAuditStateText,
  getCourseAuditStateMeta,
} from "@/components/projectShell/moduleConfig.js";
import StatusBadge from "@/components/projectShell/StatusBadge.vue";
import sectionFilledMixin from "@/components/projectShell/sectionFilledMixin.js";
export default {
  mixins: [sectionFilledMixin],
  name: "",
  components: {
    BaseInfo,
    TeamInfo,
    Budget,
    CapitalExpenditure,
    Effect,
    Activity,
    BrandBuilding,
    Honor,
    Propaganda,
    PracticeBase,
    AnnualPlan,
    EducatingPeople,
    Achievement,
    RateTable,
    RateIcon,
    rightDialog,
    newpreview,
    videopreview,
    StatusBadge,
  },
  props: {
    editInfo: { type: Object, default: null },
    news: { type: String },
  },
  data() {
    return {
      brandModules: this.$store.state.user.brandModules, // 教师负责模块
      baseInfoTitle: "品牌团队",
      budgetTitle: "品牌资金预算",
      capitalExpenditureTitle: "品牌资金使用",
      annualPlanTitle: "年度计划",
      educatingPeopleTitle: "思政育人",
      achievementTitle: "品牌成果",
      sections: [
        {
          title: "品牌基本信息",
          id: "baseInfo",
        },
        {
          title: "品牌团队",
          id: "teamInfo",
        },
        {
          title: "品牌资金预算",
          id: "budget",
        },
        {
          title: "品牌资金使用",
          id: "capitalExpenditure",
        },
        {
          title: "年度计划",
          id: "annualPlan",
        },
        {
          title: "品牌活动",
          id: "activity",
        },
        {
          title: "品牌建设",
          id: "brandBuilding",
        },
        {
          title: "思政育人",
          id: "educatingPeople",
        },
        {
          title: "品牌成果",
          id: "achievement",
        },
        // {
        //   title: "品牌荣誉",
        //   id: "honor",
        // },
        {
          title: "品牌宣传",
          id: "brandPropaganda",
        },
        {
          title: "品牌效果",
          id: "result",
        },
        // {
        //   title: "品牌基地",
        //   id: "practiceBase",
        // },
      ],
      baseInfo: null,
      id: null,
      activeSection: 0,
      isAdd: true,
      isEdit: false,
      isRevise: false,
      isClickEdit: false,
      isMul: 0,
      content: "",
      visible: false,
      record: {},
      vsVisible: false,
      activeItem: 0,
      // 对比
      vsVisible: false,
      isShowVsIcon: false,
      activeItem: 0,
      // 审核详情文件查看
      showiframe: false,
      previewUrl: "",
      dialogTitle: "",
      // 视频预览
      showvideo: false,
      sjData: {},
      loading: false,
      draftLoading: false,
    };
  },
  computed: {
    showFooterActions() {
      const role = this.$store.state.role;
      if (role != "school-role" && role != "teacher-role") return false;
      if (!this.baseInfo || !this.baseInfo.id) return false;
      if (this.baseInfo.auditState == "1") return false;
      if (
        this.$route.query.new == "preview" ||
        this.$route.query.new == "audit" ||
        this.news == "preview" ||
        this.news == "audit"
      ) {
        return false;
      }
      return true;
    },
    /** 仅从「审核」入口进入才显示通过/驳回；「预览」只读 */
    isAuditEntryMode() {
      const mode = this.$route.query.new || this.news;
      return mode === "audit";
    },
    /** 与列表状态文案一致：学校仅「待学校审核」，审核员仅「待教育局/厅审核」 */
    canShowAuditActions() {
      if (!this.isAuditEntryMode) return false;
      if (!this.baseInfo || String(this.baseInfo.auditState) !== "1") {
        return false;
      }
      const role = this.$store.state.role;
      const stageText = getCourseAuditStateText(this.baseInfo);
      if (role === "school-role") return stageText === "待学校审核";
      if (role === "audit-role" || role === "education-role") {
        return stageText === "待教育局/厅审核";
      }
      return canRoleAuditAtLevel(
        role,
        this.baseInfo.auditState,
        this.baseInfo.auditLevel
      );
    },
    statusBadgeText() {
      if (!this.baseInfo || !this.baseInfo.id) return "新建";
      return getCourseAuditStateMeta(this.baseInfo).text;
    },
    statusBadgeType() {
      if (!this.baseInfo || !this.baseInfo.id) return "blue";
      return getCourseAuditStateMeta(this.baseInfo).badge;
    },
    editingStatusText() {
      const mode = this.$route.query.new || this.news;
      if (mode === "preview") return "只读预览";
      if (mode === "audit") return "审核查看";
      if (!this.baseInfo || !this.baseInfo.id) return "新建填报";
      if (String(this.baseInfo.auditState) === "1") return "待审核";
      if (String(this.baseInfo.auditState) === "2") return "已通过版本";
      if (String(this.baseInfo.auditState) === "3") return "驳回修改";
      return "草稿编辑";
    },
  },
  watch: {
    editInfo: {
      handler(newValue, oldValue) {
        if (newValue !== null) {
          const isPreview =
            this.$route.query.new == "preview" ||
            this.$route.query.new == "audit" ||
            this.news == "preview" ||
            this.news == "audit" ||
            newValue.type == "preview";
          // 先打预览标记再下发，避免子组件初始化时仍可编辑
          if (
            isPreview ||
            this.$store.state.role == "education-role" ||
            this.$store.state.role == "score-role" ||
            this.$store.state.role == "education-guide-role" ||
            this.$store.state.role == "audit-role"
          ) {
            newValue.type = "preview";
          }

          this.baseInfo = newValue;
          this.id = newValue.id;
          this.$refs.baseInfoRef.info = newValue;
          this.$refs.teamInfoRef.oldInfo = newValue;

          if (
            this.$store.state.role == "education-role" ||
            this.$store.state.role == "score-role" ||
            this.$store.state.role == "education-guide-role" ||
            this.$store.state.role == "audit-role"
          ) {
            this.isEdit = true;
            this.editInfo.type = "preview";
            this.isRevise = true;
          } else {
            if (
              this.baseInfo.auditState == 1
              // ||
              // this.baseInfo.auditState == 2
            ) {
              this.isEdit = true;
              this.editInfo.type = "preview";
            } else {
              this.isEdit = false;
              if (!isPreview) this.editInfo.type = "";
            }
          }

          if (this.isRevise == false && !isPreview) {
            this.isEdit = false;
            this.editInfo.type = "";
          } else {
            // this.isEdit = true;
            // this.editInfo.type = "preview";
          }
          if (
            !isPreview &&
            (this.$store.state.role === "school-role" ||
              this.$store.state.role === "teacher-role") &&
            this.baseInfo &&
            (this.baseInfo?.auditState == "1" ||
              this.baseInfo?.auditState == "2")
          ) {
            this.onRevise();
          }
          if (isPreview) {
            this.isEdit = true;
            this.editInfo.type = "preview";
            this.isRevise = true;
          }
        } else {
          this.baseInfo = null;
          this.id = null;
          this.$refs.baseInfoRef.info = null;
          this.$refs.teamInfoRef.oldInfo = null;
          this.isEdit = false;
          this.editInfo.type = "";
        }
      },
      deep: true,
    },
  },
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  created() {
    if (!this.editInfo) {
      this.isRevise = true;
    }
    console.log("index2 created this.editInfo", this.editInfo);
    // if (this.editInfo !== null) {
    //   this.baseInfo = this.editInfo;
    // }
  },
  methods: {
    handlePreview(data, key) {
      console.log("🚀 ~ handlePreview ~ data, key:", data, key);
      const currentFileList = FILE_VIEW_MAP[2].PPJIBENXINXI;
      console.log("🚀 ~ handlePreview ~ currentFileList:", currentFileList);
      const fileViewKeyList = Object.keys(currentFileList);
      console.log("🚀 ~ handlePreview ~ fileViewKeyList:", fileViewKeyList);
      if (fileViewKeyList.includes(key)) {
        const currentUrlName = currentFileList[key].urlName;
        const currentName = currentFileList[key].name;
        console.log("🚀 ~ handlePreview ~ currentName:", currentName);
        console.log("🚀 ~ handlePreview ~ currentUrlName:", currentUrlName);
        console.log(
          "🚀 ~ handlePreview ~ data[currentUrlName]:",
          data[currentUrlName]
        );
        if (data[currentUrlName] != "" && data[currentUrlName] != null) {
          if (data[currentUrlName].includes(".mp4")) {
            this.showvideo = true;
            this.sjData = {
              url: data[currentUrlName],
              title: `${currentName}预览`,
              aliId: data.aliId,
            };
            return;
          }
          this.showiframe = true;
          console.log("this.showiframe", this.showiframe);
          this.previewUrl = data[currentUrlName];
          this.dialogTitle = `${currentName}预览`;
        }
      }
    },
    handleOks() {
      if (this.content == "") {
        this.$message.warning("请填写驳回理由");
        return false;
      }
      let params = {};
      params.auditState = 3;
      params.applyIds = [];
      if (this.isMul == "0") {
        params.applyIds.push(this.record.id);
      } else {
        // params.applyIds = this.selectedRowKeys;
      }

      params.auditDesc = this.content;
      params.auditLevel = getAuditLevel(this.$store.state.role);
      postAction("/lx/lxApply/auditBatch", params).then((res) => {
        if (res.code === 200) {
          this.$message.success("审核驳回成功");
          this.visible = false;
          // this.selectedRowKeys = [];
          this.isMul = 0;
          this.$router.go(-1);
          // this.inquire();
        }
      });
    },
    approved(num, record) {
      //		console.log(num,record);
      let params = {};
      if (num == "0") {
        const that = this;
        this.$confirm({
          title: "确定要审核通过吗？",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            return postAction("/lx/lxApply/auditBatch", {
              auditState: 2,
              applyIds: [record.id],
              auditLevel: getAuditLevel(that.$store.state.role),
            }).then((res) => {
              if (res.code === 200) {
                that.$message.success("审核通过成功");
                that.$router.go(-1);
              } else {
                that.$message.error(res.message || "审核通过失败");
              }
            });
          },
        });
      } else {
        this.isMul = 0;
        this.content = "";
        this.visible = true;
        this.record = record;
      }
    },
    onShowRateTable() {
      this.$refs.rateTable.init(this.baseInfo, 2);
    },
    // 点击编辑按钮
    onRevise() {
      this.isRevise = false;
    },
    saveDraft() {
      if (this.draftLoading || this.loading) return;
      if (!this.$refs.baseInfoRef) return;
      if (!this.$refs.baseInfoRef.validateName()) return;
      this.draftLoading = true;
      this.$refs.baseInfoRef
        .save(true, { silent: true })
        .then(() => {
          this.$message.success("暂存成功");
        })
        .catch(() => {})
        .finally(() => {
          this.draftLoading = false;
        });
    },
    option() {
      if (this.loading || this.draftLoading) return;
      if (!this.$refs.baseInfoRef) return;
      // 提交：基本信息必填 + 各下级模块至少一条并校验行内必填
      const required = [
        { ref: "baseInfoRef", id: "baseInfo" },
        { ref: "teamInfoRef", id: "teamInfo", emptyMsg: "请添加品牌团队" },
        { ref: "budgetRef", id: "budget", emptyMsg: "请添加品牌资金预算" },
        {
          ref: "capitalExpenditureRef",
          id: "capitalExpenditure",
          emptyMsg: "请添加品牌资金使用",
        },
        { ref: "annualPlanRef", id: "annualPlan", emptyMsg: "请添加年度计划" },
        { ref: "activityRef", id: "activity", emptyMsg: "请添加品牌活动" },
        {
          ref: "teamBuildingRef",
          id: "brandBuilding",
          emptyMsg: "请添加品牌建设",
        },
        {
          ref: "educatingPeopleRef",
          id: "educatingPeople",
          emptyMsg: "请添加思政育人",
        },
        {
          ref: "achievementRef",
          id: "achievement",
          emptyMsg: "请添加品牌成果",
        },
        {
          ref: "PropagandaRef",
          id: "brandPropaganda",
          emptyMsg: "请添加品牌宣传",
        },
        { ref: "resultRef", id: "result", emptyMsg: "请添加品牌效果" },
      ];
      for (let i = 0; i < required.length; i++) {
        const item = required[i];
        const comp = this.$refs[item.ref];
        if (!comp || typeof comp.validate !== "function") {
          if (item.emptyMsg) {
            this.$message.info(item.emptyMsg);
            const el = document.querySelector("#" + item.id);
            if (el) el.scrollIntoView({ behavior: "smooth" });
            return;
          }
          continue;
        }
        if (!comp.validate()) {
          const el = document.querySelector("#" + item.id);
          if (el) el.scrollIntoView({ behavior: "smooth" });
          return;
        }
      }
      this.loading = true;
      this.$refs.baseInfoRef
        .save(false, { silent: true })
        .then(() => this.submitApply())
        .catch(() => {
          this.loading = false;
        });
    },
    submitApply() {
      const done = (res) => {
        if (res.code === 200) {
          window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
          this.$router.push({ name: "educationalBrand" });
        } else {
          this.$message.info(res.message);
        }
        this.loading = false;
        return res;
      };
      if (this.baseInfo.auditState == "0" || this.baseInfo.auditState == "3") {
        return postAction("/lx/lxApply/submitBatch", {
          applyIds: [this.baseInfo.id],
        }).then(done);
      }
      return this.$confirm({
        title: "确认提交变更",
        content:
          "提交后将由学校或教育局整批审核，审核通过后才会写入项目并生成新版本。",
        okText: "确认提交",
        cancelText: "取消",
        onOk: () =>
          getAction(
            "/audit/lxAuditTask/submit?applyId=" + this.baseInfo.id,
            {}
          ).then(done),
      }).catch(() => {
        this.loading = false;
      });
    },
    goStep(item) {
      this.baseInfo = item;
      this.editInfo = item;
      if (this.isShowVsIcon && this.$refs.rightDialog?.visible) {
        this.$refs.rightDialog.init(this.baseInfo, "2");
      }
    },
    editGo(index) {
      this.activeSection = index;
      this.activeItem = index;
      this.$nextTick(() => this.refreshSectionFilled());
      if (
        this.editInfo?.id &&
        this.editInfo?.auditState == "2" &&
        (this.$store.state.role == "school-role" ||
          this.$store.state.role == "teacher-role")
      ) {
        this.handleShowVsIcon();
      }
    },
    editPrev() {
      if (this.activeSection > 0) {
        this.editGo(this.activeSection - 1);
      }
    },
    editNext() {
      if (this.activeSection < this.sections.length - 1) {
        this.editGo(this.activeSection + 1);
      }
    },
    goBack() {
      this.$router.push({ name: "educationalBrand" });
    },
    handleShowVsIcon() {
      // console.log(
      //   !this.diffData || this.activeItem != 0,
      //   "🚀 ~ handleShowVsIcon ~ !this.diffData || this.activeItem != 0:",
      //   !this.diffData,
      //   this.activeItem != 0
      // );
      if (this.activeItem != 0) {
        this.isShowVsIcon = false;
        this.$refs.rightDialog.close();
      } else {
        this.isShowVsIcon = true;
      }
    },
    onShowVs() {
      this.$refs.rightDialog.init(this.baseInfo, "2");
    },
  },
  mounted() {
    if (this.editInfo?.id && this.editInfo?.auditState == "2") {
      this.handleShowVsIcon();
    }
    window.scrollTo(0, 0);
    this.isAdd = this.$route.query.new == "new";
    if (this.editInfo !== null) {
      this.step1 = this.editInfo;
      this.baseInfo = this.editInfo;
      this.id = this.editInfo.id;
      this.$refs.baseInfoRef.info = this.editInfo;
      this.$refs.teamInfoRef.oldInfo = this.editInfo;
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/components/projectShell/updatePage.scss";

.vs-icon {
  position: fixed;
  top: 385px;
  right: 14%;
  width: 45px;
  height: 45px;
  cursor: pointer;
  z-index: 20;
}
@media (max-width: 1441px) {
  .vs-icon {
    top: 165px;
    right: 2%;
  }
}
</style>